// Initial state
export const initialState = {
  feedbacks: [],
  userName: '',
};

// Reducer
export default function feedback(state = initialState, action) {
  switch (action.type) {
    case 'ADD_FEEDBACK': {
      const newFeedback = action.payload;
      const existingFeedbacks = state.feedbacks;
      
      // Check if feedback with the same type already exists
      const feedbackExists = existingFeedbacks.some(feedback => feedback.type === newFeedback.type);

      return {
        ...state,
        feedbacks: feedbackExists
          ? existingFeedbacks.map(feedback =>
              feedback.type === newFeedback.type ? newFeedback : feedback
            )
          : [...existingFeedbacks, newFeedback],
      };
    }
    case 'RESET_FEEDBACK': {
      return {
        ...state,
        feedbacks: [],
      };
    }
    case 'REMOVE_FEEDBACK_BY_TYPE': {
      const typeToRemove = action.payload;
      return {
        ...state,
        feedbacks: state.feedbacks.filter(feedback => feedback.type !== typeToRemove),
      };
    }
    case 'SET_USER_NAME_FEEDBACK': {
      return {
        ...state,
        userName: action.payload,
      };
    }
    case 'RESET_USER_NAME_FEEDBACK': {
      return {
        ...state,
        userName: '',
      };
    }
    default:
      return state;
  }
}